import { AccountContext } from '../../contexts/Account/AccountContext.tsx';
import { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth.tsx';
import { useNotification } from '../NotificationProvider.tsx';
import { NotificationStatus } from '../../components/notification/Notification.tsx';
import apiNet from '../../newApi/apiNet.ts';
import axios, { AxiosError } from 'axios';
import { AxiosException } from '../../exceptions/axiosException.ts';
import { useAccountRecording } from '../../hooks/account/useAccountRecording.tsx';
import { useAppDispatch } from '../../stores/store.ts';
import { accountFavoritesActions } from '../../components/account/favorite/accountFavoritesSlice.ts';
import { authActions } from '../../components/auth/authSlice.ts';
import { accountNotificationsActions } from '../../components/account/notification/accountNotificationsSlice.ts';
import { accountRemindersActions } from '../../components/account/reminder/accountRemindersSlice.ts';

interface IProps {
    children: ReactNode;
}

const AccountProvider = ({ children }: IProps) => {
    const _authService = useAuth();
    const _dispatch = useAppDispatch();
    const { updateRecordingsBasic } = useAccountRecording();
    // const {} = useAcF
    // const _location = useLocation();
    // const _navigate = useNavigate();
    const _notification = useNotification();
    const changePassword = async (actualPassword: string, password: string, confirmPassword: string, logoutFromAllDevices: boolean) => {
        try {
            await apiNet.accountChangePassword(actualPassword, password, confirmPassword, logoutFromAllDevices);
        } catch (e) {
            const error = e as Error | AxiosError;
            if (axios.isAxiosError(error) && error.response) {
                if (error.response.status === 404) {
                    await _authService.logout();
                    _notification.showNotification('Niepowodzenie', 'Żądanie nie mogło zostać obsłużone. Proszę się zalogować ponownie i powtórzyć operację.', NotificationStatus.failure);
                }
                new AxiosException(error.response.status, error.response.data.MsgCode, error.response.data.Messege);
            }
            throw new Error(axios.isAxiosError(error) && error.response && error.response.data ? error.response.data : 'Something went wrong...');
        }
    };

    const getMe = async (rememberMe: boolean) => {
        try {
            const response = await apiNet.getMe();
            const user = {
                id: response.data.user.id,
                roles: response.data.user.roles,
                customerId: response.data.user.customer_id,
            };
            _dispatch(authActions.setCredentials({
                user,
                accessToken: '',
                rememberMe: rememberMe,
            }));
            updateRecordingsBasic(response.data.recordings);
            _dispatch(accountFavoritesActions.updateAllFromDTO(response.data.favorites));
            _dispatch(accountNotificationsActions.updateAllFromDTO(response.data.notifications));
            _dispatch(accountRemindersActions.updateAllFromDTO(response.data.reminders));
        } catch (error) {
            throw new Error(axios.isAxiosError(error) && error.response && error.response.data ? error.response.data : 'Something went wrong...');
        }
    };

    // const logoutFromAllDevices = async () => {
    //     try {
    //         await _authService.logoutFromAllDevices();
    //         _navigate("/");
    //         _notification.showNotification("Sukces", "Zostałeś wylogowany ze wszystkich urządzeń.", NotificationStatus.success)
    //     } catch (e) {
    //         const error = e as Error | AxiosError;
    //         if (axios.isAxiosError(error) && error.response) {
    //             if (error.response.status === 404) {
    //                 await _authService.logout();
    //                 _notification.showNotification("Niepowodzenie", "Żądanie nie mogło zostać obsłużone. Proszę się zalogować ponownie i powtórzyć operację.", NotificationStatus.failure);
    //             }
    //             new AxiosException(error.response.status, error.response.data.MsgCode, error.response.data.Messege)
    //         }
    //         _notification.showNotification("Niepowodzenie", "Wylogowanie nie powiodło się. Wystąpił błąd po stronie serwera. Spróbuj ponownie za kilka minut.", NotificationStatus.failure)
    //         throw InternalServerErrorException("Something went wrong...");
    //     }
    // }

    // useEffect(() => {
    //     if (!_authService.isRefreshTokenAvailable) {
    //         _navigate(`/logowanie?redirectTo=${_location.pathname}`);
    //         _notification.showNotification("Brak dostępu", "Zaloguj się, aby uzyskać dostęp.", NotificationStatus.failure);
    //     }
    // }, [_authService.isRefreshTokenAvailable, _location]);

    return <AccountContext.Provider value={{ changePassword, getMe }}>
        {/*<AccountPageNav/>*/}
        {/*<div className={"mt-2 md:mt-0 md:pt-4 flex-1 flex flex-col mb-4"}>*/}
        {/*    <div className={"animate-opacityEaseIn flex-1"}>*/}
        {/*        {children}*/}
        {/*    </div>*/}
        {/*</div>*/}
        {/* <Footer/> */}
        {children}
    </AccountContext.Provider>;
};

export default AccountProvider;